// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { primaryImageStyles } from "@west/Overrides/Widgets/ProductDetails/ProductDetailsPrimaryImage";
import { avoidBreakInsidePrintElement } from "@west/XDL/Utilities";
import { css } from "styled-components";

primaryImageStyles.fullPrimaryImageModal = {
    cssOverrides: {
        modalContainer: css`
            width: auto;
        `,
        modalBody: css`
            width: auto;
            max-width: initial;
        `,
        modalTitle: css`
            border-bottom: none;
            padding: 5px 5px 0 0;
            &:after {
                display: none;
            }
        `,
        modalContent: css`
            text-align: center;
            padding: 20px;
            .expand {
                display: none;
            }
        `,
    },
};

primaryImageStyles.fullPrimaryImage = {
    img: {
        css: css`
            cursor: auto;
            width: auto;
            max-height: 70vh;
        `,
    },
};

const sharedPrimaryImageStyle = {
    centeringWrapper: {
        css: css`
            min-height: 204px;
            height: 430px;
            margin: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            ${avoidBreakInsidePrintElement}
            img {
                height: auto;
                max-width: 100%;
                max-height: 100%;
            }
        `,
    },
    image: {
        css: css`
            margin: auto;
            cursor: pointer;
        `,
    },
    img: {
        css: css`
            cursor: pointer;
        `,
    },
};

primaryImageStyles.primaryVideo = {
    centeringWrapper: {
        ...sharedPrimaryImageStyle.centeringWrapper,
    },
    img: {
        ...sharedPrimaryImageStyle.img,
    },
};

primaryImageStyles.primaryImage = {
    centeringWrapper: {
        ...sharedPrimaryImageStyle.centeringWrapper,
    },
    img: {
        ...sharedPrimaryImageStyle.img,
    },
};

primaryImageStyles.badgeImageWrapper = {
    css: css`
        position: absolute;
        height: 23px;
        max-height: 23px;

        img {
            width: auto;
            height: auto;
            max-width: 100%;
            max-height: 100%;
        }
    `,
};

primaryImageStyles.lazyBadgeImageStyles = {
    css: css`
        height: 23px;
        max-height: 23px;
        img {
            width: auto;
        }
    `,
};
